<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                <dl class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>See Details</i>
                    </dt>
                    <dd>
                        <div class="view_cont">
                            <div class="view_info">
                                <div class="view_category"> 
                                    {{ knowledgeDetail.PRD_CATEGORY_NM1 }}
                                    <template v-if="typeof knowledgeDetail.PRD_CATEGORY_NM2 !== 'undefined'">&gt; {{ knowledgeDetail.PRD_CATEGORY_NM2 }}</template>
                                    <template v-if="typeof knowledgeDetail.PRD_CATEGORY_NM3 !== 'undefined'">&gt; {{ knowledgeDetail.PRD_CATEGORY_NM3 }}</template>
                                </div>
                            </div>
                            <dl class="view_subject">
                                <dt class="subject">
                                    <em v-if="knowledgeDetail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                    <em v-else-if="knowledgeDetail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                    {{ knowledgeDetail.KNOWLEDGE_TITLE }}
                                </dt>
                                <dd class="desc hhp_desc">
                                    <span class="desc_Regist"><em>Registered by</em>{{ knowledgeDetail.REG_USER_NM }}({{ knowledgeDetail.CORP_NM }}) ({{ knowledgeDetail.REG_DT }})</span>
                                    <span class="desc_modify"><em>Last Modified by</em>{{ knowledgeDetail.MODF_USER_NM }} ({{ knowledgeDetail.MODF_DT }})</span><br>
                                    <span class="desc_Target"><em>Target</em>{{ knowledgeDetail.DIST_TARGET }}</span>
                                    <span class="desc_AllowSharing"><em>Allow Sharing </em>{{ knowledgeDetail.ALLOW_SHARE }}  </span>
                                </dd>
                            </dl>
                            <!-- tab -->
                            <div class="view_desc">
                                <div class="grid_wrap">
                            <!-- Count -->
                            <!-- <div class="grid_total">
                                Total&nbsp;Count&nbsp;
                                <em>{{ totalCount | numberFormat }}</em>
                            </div> -->
                                <div class="btn_wrap">
                                    <a
                                            href="javascript:"
                                            class="btn_white"
                                            @click="excelDownload()"
                                            title
                                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                                </div>
                                <!-- Grid -->
                                <toast-grid
                                    :gridId="gridId"
                                    :data="gridData"
                                    :columns="columns"
                                    :options="options"
                                    :key="gridKey"
                                    :pageOptions="pageOptions"
                                    :isTotalCount="true"
                                />
                            </div>
                            </div>
                        </div>
                    </dd>
                </dl>

            </div>
        </div>
    </div>
</template>

<script>
import Vue                  from 'vue';
import axios                from 'axios';
import qs                   from 'query-string';
import $                    from 'jquery';
import store                from '@/vuex/store';
import SDLUtil              from '@/utils/SDLUtil';
import ToastGrid            from '~c/ToastGrid';
import { EventBus }         from '@/utils/EventBus';
import ExcelDownloadPopup   from '~vb/common/ExcelDownloadPopup';

export default {
    name: 'searchUserPop',
    components: {
        'toast-grid': ToastGrid,
    },
    props : ['knowledgeId', 'corpNo', 'searchDate'],
    data() {
        return {
            pageName: 'unreadPop',
            loginId: '',
            loginNo: '',
            loginNm: '',

            knowledgeDetail: {},

            //currentPage: 1,
            //totalCount : 0,
            gridId: 'unreadPopListGrid',
            gridKey: 0,
            columns: [
                {
                    header: 'User ID',
                    name: 'LOGIN_ID',
                    align: 'center',
                    width: 200,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Name',
                    name: 'LOGIN_NAME',
                    align: 'center',
                    width: 300,
                    resizable: true,
                    sortable: false,
                    filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} }
                },
                // {
                //     header: 'Subsidiary',
                //     name: 'CORP_NM',
                //     align: 'center',
                //     width: 100,
                //     resizable: true,
                //     sortable: false,
                // },
                {
                    header: 'ASC Account No.',
                    name: 'ACCOUNT_NO',
                    align: 'center',
                    width: 150,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Last Log-in',
                    name: 'LAST_LOGIN',
                    align: 'center',
                    //width: 200,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 265,
            },
            pageOptions: {
                useClient: true,
                perPage: 10,
            },
        };
    },
    created() {
        
    },

    mounted() {
        this.onSearch();
    },
    methods: {
        async onSearch() {

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerUnreadPopup.skp`,
                    qs.stringify({
                        KNOWLEDGE_ID : this.knowledgeId, 
                        CORP_NO : this.corpNo,
                        VIEW_DATE : this.searchDate
                    }),
                )
                .then(resp => {
                    this.knowledgeDetail = resp.data.knowledge[0];
                    this.gridData = resp.data.ASCUser;
                    this.gridKey++; 
                    //this.totalCount = resp.data.rowCount;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerUnreadPopupListExcel.skp`,
                            qs.stringify({
                                KNOWLEDGE_ID : this.knowledgeId, 
                                CORP_NO : this.corpNo,
                                VIEW_DATE : this.searchDate
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/UnreadPop.vue